var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 150 150",
    fill: "#025add",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.688 132.653h-17.017a1 1 0 0 1 -1-1v-41.253a1 1 0 0 1 1-1h17.017a1 1 0 0 1 1 1v41.254a1 1 0 0 1 -1 .999zm-16.017-2h15.017v-39.253h-15.017z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m67.9 132.653h-17.015a1 1 0 0 1 -1-1v-59.983a1 1 0 0 1 1-1h17.015a1 1 0 0 1 1 1v59.983a1 1 0 0 1 -1 1zm-16.016-2h15.016v-57.983h-15.015z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m99.115 132.653h-17.015a1 1 0 0 1 -1-1v-78.713a1 1 0 0 1 1-1h17.015a1 1 0 0 1 1 1v78.713a1 1 0 0 1 -1 1zm-16.016-2h15.016v-76.713h-15.015z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m130.329 132.653h-17.017a1 1 0 0 1 -1-1v-97.442a1 1 0 0 1 1-1h17.017a1 1 0 0 1 1 1v97.442a1 1 0 0 1 -1 1zm-16.017-2h15.017v-95.442h-15.017z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m139 140h-128a1 1 0 0 1 -1-1v-7.347a1 1 0 0 1 1-1h128a1 1 0 0 1 1 1v7.347a1 1 0 0 1 -1 1zm-127-2h126v-5.347h-126z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32.711 70.673a1 1 0 0 1 -.509-1.862l22.27-13.15a1 1 0 0 1 1.016 1.723l-22.27 13.149a.985.985 0 0 1 -.507.14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m95.351 33.7a1 1 0 0 1 -.509-1.862l22.33-13.18a1 1 0 1 1 1.016 1.723l-22.33 13.182a.985.985 0 0 1 -.507.137z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m64.041 52.183a1 1 0 0 1 -.509-1.862l22.29-13.16a1 1 0 0 1 1.016 1.723l-22.29 13.159a.985.985 0 0 1 -.507.14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m28.179 78.614a6.268 6.268 0 1 1 6.267-6.268 6.275 6.275 0 0 1 -6.267 6.268zm0-10.535a4.268 4.268 0 1 0 4.267 4.267 4.272 4.272 0 0 0 -4.267-4.267z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m59.393 59.92a6.267 6.267 0 1 1 6.267-6.267 6.274 6.274 0 0 1 -6.267 6.267zm0-10.534a4.267 4.267 0 1 0 4.267 4.267 4.272 4.272 0 0 0 -4.267-4.267z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m90.607 41.227a6.267 6.267 0 1 1 6.267-6.267 6.274 6.274 0 0 1 -6.267 6.267zm0-10.534a4.267 4.267 0 1 0 4.267 4.267 4.272 4.272 0 0 0 -4.267-4.267z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m121.821 22.534a6.267 6.267 0 1 1 6.267-6.267 6.274 6.274 0 0 1 -6.267 6.267zm0-10.534a4.267 4.267 0 1 0 4.267 4.267 4.272 4.272 0 0 0 -4.267-4.267z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m23.671 115.833a1 1 0 0 1 -1-1v-17.921a1 1 0 0 1 2 0v17.921a1 1 0 0 1 -1 1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m23.671 128.652a1 1 0 0 1 -1-1v-7.652a1 1 0 0 1 2 0v7.652a1 1 0 0 1 -1 1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m54.885 115.833a1 1 0 0 1 -1-1v-36.587a1 1 0 0 1 2 0v36.587a1 1 0 0 1 -1 1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m54.885 128.652a1 1 0 0 1 -1-1v-7.652a1 1 0 0 1 2 0v7.652a1 1 0 0 1 -1 1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m86.1 115.833a1 1 0 0 1 -1-1v-53.754a1 1 0 1 1 2 0v53.754a1 1 0 0 1 -1 1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m86.1 128.652a1 1 0 0 1 -1-1v-7.652a1 1 0 0 1 2 0v7.652a1 1 0 0 1 -1 1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m117.312 115.833a1 1 0 0 1 -1-1v-70.421a1 1 0 1 1 2 0v70.421a1 1 0 0 1 -1 1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m117.312 128.652a1 1 0 0 1 -1-1v-7.652a1 1 0 0 1 2 0v7.652a1 1 0 0 1 -1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSeo);
export default __webpack_public_path__ + "static/media/service-seo.0c0c9be9216c781acb8228dc2be55c86.svg";
export { ForwardRef as ReactComponent };